import httpService from "@/services/httpService";

export default {
  getLookupValues: async (metadataId, isThirdParty) =>
    httpService.get("/metadata/" + metadataId + "/lookupvalues" + (isThirdParty ? "?isThirdParty=true" : "")),
};
